import { useEffect } from 'react';
import styled from 'styled-components';
import configAPI from "../../../configAPI.json";
import { SessionData, useSessionStore } from '../../../hooks/stores/sessionStore';
import { UIData, useUIStore } from '../../../hooks/stores/uiStore';
import { Modal } from '../../common/Modal';
import { TextButton } from '../../common/TextButton';
import { useScene } from '../../../context/sceneContext';

export const ConnectModal = () => {
  const scene = useScene();
  const [sessionData] = useSessionStore<SessionData>();
  const [UIData] = useUIStore<UIData>();


  const isOpen = UIData.openModalIDs.includes('connectModal');
  const isUserLoggedIn = sessionData.email !== null;

  useEffect(() => {
    if (sessionData.themeID === null) {
      scene.openModal('connectModal');
    } else {
      scene.closeModal('connectModal');
    }
  }, [sessionData.themeID]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => scene.closeModal('connectModal')}
      label='You are not connected'
    >
      <p style={{ marginTop: 0 }}>
        To be able to save your changes, add assets and use the theme in the
        launcher - you need to create a theme through the PatchKit panel and
        from there open it in the editor.
      </p>

      <p>If you are just looking around - go ahead</p>
      <CenteringContainer>
        <TextButton
          $type="secondary"
          onClick={() => scene.closeModal('connectModal')}
          style={{ width: '250px', textAlign: 'center' }}
        >
          Go to the editor
        </TextButton>
      </CenteringContainer>

      <p>If you want to create a theme for your launcher</p>
      <CenteringContainer>
        <TextButton
          $type="primary"
          onClick={() => window.open(configAPI.endpoints.themesPage, '_blank')}
          style={{ width: '250px', textAlign: 'center' }}
        >
          {!isUserLoggedIn ? 'Log in and' : ''} Create a theme on PatchKit
        </TextButton>
      </CenteringContainer>
    </Modal>
  );
};

const CenteringContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
